import { View } from 'react-native';
import { Divider } from '@ui-kitten/components';

import ListItemLoader from '../../Components/ListItemLoader';
import { RectangleLoader } from '../../Components/Loader';
import { styles as reservationStyles } from '../../Components/Reservation/styles';
import ResponsiveLayout from '../../Components/ScreenWrapper/ResponsiveLayout';
import { numberToArray } from '../../Helper';
import themeStyle from '../../Theme/styles';

import { ids, styles } from './index.web';
import TicketLoader from './TicketLoader';

const PageLoaderWeb = ({
  isCheckoutSuccess,
  isReservation,
}: {
  isCheckoutSuccess?: boolean;
  isReservation?: boolean;
}) => {
  return (
    <ResponsiveLayout
      LeftComponent={
        <View style={[themeStyle.flex1, themeStyle.justifyContentCenter]}>
          {isCheckoutSuccess && (
            <View style={themeStyle.spacingBottom}>
              <ListItemLoader
                contentContainerStyle={themeStyle.spacingBottomSmall}
                leftSize={50}
                textSize={47.5}
                withLeftIcon
              />
              <RectangleLoader width="100%" height={48} />
            </View>
          )}
          <View style={themeStyle.spacingBottom}>
            <RectangleLoader width="80%" height={45} />
          </View>
          <View style={[reservationStyles.detailsBox, { borderRadius: 10 }]}>
            <View style={themeStyle.pageVerticalSpacingMedium}>
              <View style={themeStyle.spacingBottomSmall}>
                <RectangleLoader width="70%" height={27.5} />
              </View>
              <RectangleLoader width="50%" height={24} />
            </View>
            <Divider style={themeStyle.divider} />
            {numberToArray(isReservation ? 3 : 4).map((_, i) => (
              <ListItemLoader
                key={i}
                contentContainerStyle={themeStyle.pageVerticalSpacingMedium}
                withLeftIcon
              />
            ))}
          </View>
          <View style={[reservationStyles.detailsBox, { borderRadius: 10 }]}>
            <View style={themeStyle.flexDirectionRowCenterSpaceBetween}>
              <RectangleLoader width="50%" height={25.5} />
              <View style={[themeStyle.alignSeldEnd, { width: '15%' }]}>
                <RectangleLoader height={25.5} />
              </View>
            </View>
          </View>
        </View>
      }
      RightComponent={
        !isReservation && (
          <View
            dataSet={{ media: ids.ticketContainer }}
            style={[styles.ticketContainer, themeStyle.pageVerticalSpacing]}
          >
            <TicketLoader
              contentContainerStyle={{ transform: [{ scale: 0.7 }] }}
              withShadow
            />
          </View>
        )
      }
    />
  );
};

export default PageLoaderWeb;
